import type { HandleClientError } from "@sveltejs/kit/hooks";
import * as Sentry from "@sentry/sveltekit";
import type { BrowserOptions } from "@sentry/sveltekit";
import { dev } from "$app/env";
import { navigating, page, updated } from "$app/state";
import { isErrorWithStatus } from "@fergmar/backend/errors";
import { sentryDsn } from "@fergmar/config/sentry";
import { createClientErrorLifecycle, type ClientSentry } from "@fergmar/ui/client-error-lifecycle";

const sentry: ClientSentry<Parameters<HandleClientError>[0]["event"]> = {
	init: (options) => Sentry.init(options as BrowserOptions),
	thirdPartyErrorFilterIntegration: (options) =>
		Sentry.thirdPartyErrorFilterIntegration(
			options as Parameters<typeof Sentry.thirdPartyErrorFilterIntegration>[0]
		),
	captureException: (error, context) => Sentry.captureException(error, context),
	lastEventId: () => Sentry.lastEventId(),
	handleErrorWithSentry: (handler) => Sentry.handleErrorWithSentry(handler),
	getClient: () => Sentry.getClient(),
	replayIntegration: (options) =>
		Sentry.replayIntegration(options as Parameters<typeof Sentry.replayIntegration>[0]),
	addIntegration: (integration) =>
		Sentry.addIntegration(integration as Parameters<typeof Sentry.addIntegration>[0])
};

const lifecycle = createClientErrorLifecycle<Parameters<HandleClientError>[0]["event"]>({
	dev,
	service: "fit",
	buildVersion: __FIT_COMMIT__,
	sentryDsn,
	kit: { navigating, page, updated },
	isErrorWithStatus,
	sentry
});

export const handleError: HandleClientError = lifecycle.handleError;
